import React, { Component } from 'react';
import { Container, Video , Source} from './VideoArea.style';

class VideoArea extends Component {
    render() {
        const { 
            src,
            controls,
            autoPlay,
            muted,
            loop,
            poster,
            videoRef
        } = this.props
        return (
            <Container>
                <Video src={src} ref={videoRef} loop= {loop} controls = {controls} autoPlay = {autoPlay} muted ={muted} controlsList="nodownload">
                    <Source src={src} type="video/mp4"/>
                </Video>
            </Container>
        );
    }
}

export default VideoArea;